module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/444.e56c5274.png";